/*
 * Module for the Contact Log report criteria page
 */
rs.module("content/reports/contactlogcriteria", [],

    function () {    

        // Initialize the page
        function initialize(jsSelectors) {

            var criteria = $.js(jsSelectors.criteria);

            var assignedUserSelect = criteria.js(jsSelectors.assignedUserSelect);
            var initiatingUserSelect = criteria.js(jsSelectors.initiatingUserSelect);

            // register assigned user changed event
            assignedUserSelect.change(assignedUserChanged);

            // register initiating user changed event
            initiatingUserSelect.change(initiatingUserChanged);

            // On assigned user change, set Hidden Field (to capture assigned user name) based on selected value
            function assignedUserChanged() {

                criteria.js(jsSelectors.assignedUserHidden).val(assignedUserSelect.find(":selected").text());
            }

            // On initiating user change, set Hidden Field (to capture initiating user name) based on selected value
            function initiatingUserChanged() {
                criteria.js(jsSelectors.initiatingUserHidden).val(initiatingUserSelect.find(":selected").text());
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);